import type { ReactNode } from 'react';
import styled, { css } from 'styled-components';

export const AdWrapper = styled.div<{
  children: ReactNode;
  isSticky?: boolean;
  mobileOnly?: boolean;
}>`
  ${({ isSticky }) =>
    isSticky
      ? css`
          position: sticky;
          top: 56px;
        `
      : css`
          margin-top: 42px;
        `}

  @media ${({ theme }) => theme.media.desktop} {
    ${({ mobileOnly }) =>
      mobileOnly &&
      css`
        display: none;
      `}
  }

  img {
    width: 100%;
    border-radius: 6px;
  }
`;
